module.exports = __webpack_public_path__ + "img/square-arrow-down-left.93756245.svg";